import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers, vModelDynamic as _vModelDynamic } from "vue"

const _hoisted_1 = { class: "config-manager" }
const _hoisted_2 = { class: "cm-head" }
const _hoisted_3 = { class: "panel-title" }
const _hoisted_4 = { class: "text-muted mb-0" }
const _hoisted_5 = { class: "cm-stats" }
const _hoisted_6 = { class: "cm-stat" }
const _hoisted_7 = { class: "cm-stat-value" }
const _hoisted_8 = { class: "cm-stat-label" }
const _hoisted_9 = { class: "cm-stat" }
const _hoisted_10 = { class: "cm-stat-value" }
const _hoisted_11 = { class: "cm-stat-label" }
const _hoisted_12 = { class: "cm-stat-value" }
const _hoisted_13 = { class: "cm-stat-label" }
const _hoisted_14 = { class: "cm-toolbar" }
const _hoisted_15 = ["placeholder", "aria-label"]
const _hoisted_16 = ["aria-label"]
const _hoisted_17 = ["aria-pressed", "onClick"]
const _hoisted_18 = { class: "cm-section" }
const _hoisted_19 = { class: "cm-section-title" }
const _hoisted_20 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_21 = { class: "cm-group-title" }
const _hoisted_22 = { class: "cm-count" }
const _hoisted_23 = { class: "cm-list" }
const _hoisted_24 = { class: "form-check form-switch m-0 cm-switch" }
const _hoisted_25 = ["id", "checked", "disabled", "onClick"]
const _hoisted_26 = { class: "cm-main" }
const _hoisted_27 = ["for"]
const _hoisted_28 = {
  key: 0,
  class: "cm-key"
}
const _hoisted_29 = {
  key: 1,
  class: "cm-desc"
}
const _hoisted_30 = {
  key: 2,
  class: "cm-desc"
}
const _hoisted_31 = { class: "cm-side" }
const _hoisted_32 = {
  key: 0,
  class: "cm-changed"
}
const _hoisted_33 = { class: "cm-section" }
const _hoisted_34 = { class: "cm-section-title" }
const _hoisted_35 = { class: "cm-count" }
const _hoisted_36 = { class: "text-muted" }
const _hoisted_37 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_38 = { class: "cm-list" }
const _hoisted_39 = ["aria-expanded", "onClick"]
const _hoisted_40 = { class: "cm-main" }
const _hoisted_41 = { class: "cm-name" }
const _hoisted_42 = {
  key: 0,
  class: "cm-desc"
}
const _hoisted_43 = { class: "cm-preview" }
const _hoisted_44 = {
  key: 0,
  class: "cm-changed"
}
const _hoisted_45 = {
  key: 0,
  class: "cm-editor"
}
const _hoisted_46 = ["for"]
const _hoisted_47 = ["id", "type"]
const _hoisted_48 = ["id", "rows"]
const _hoisted_49 = {
  key: 2,
  class: "cm-error"
}
const _hoisted_50 = {
  key: 3,
  class: "cm-desc"
}
const _hoisted_51 = { class: "cm-actions" }
const _hoisted_52 = { class: "cm-meta" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_PanelNoAccess = _resolveComponent("PanelNoAccess")!
  const _component_StateBlock = _resolveComponent("StateBlock")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.$t('panel.config.title')), 1),
        _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t('panel.config.subtitle')), 1)
      ]),
      _createVNode(_component_BaseButton, {
        variant: "secondary",
        icon: "fas fa-sync-alt",
        loading: _ctx.loading,
        onClick: _ctx.loadConfigs
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('panel.config.refresh')), 1)
        ]),
        _: 1
      }, 8, ["loading", "onClick"])
    ]),
    (_ctx.forbidden)
      ? (_openBlock(), _createBlock(_component_PanelNoAccess, { key: 0 }))
      : (_openBlock(), _createBlock(_component_StateBlock, {
          key: 1,
          loading: _ctx.loading && _ctx.configs.length === 0,
          empty: !_ctx.loading && _ctx.configs.length === 0,
          "empty-text": _ctx.$t('panel.config.empty'),
          "loading-text": _ctx.$t('panel.config.loading')
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.flagsOn), 1),
                _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t('panel.config.statOn', { total: _ctx.flags.length })), 1)
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.flags.length - _ctx.flagsOn), 1),
                _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t('panel.config.statOff')), 1)
              ]),
              _createElementVNode("div", {
                class: _normalizeClass(["cm-stat", { 'is-changed': _ctx.changedCount > 0 }])
              }, [
                _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.changedCount), 1),
                _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t('panel.config.statChanged')), 1)
              ], 2)
            ]),
            _createElementVNode("div", _hoisted_14, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.query) = $event)),
                type: "search",
                class: "form-control cm-search",
                placeholder: _ctx.$t('panel.config.searchPlaceholder'),
                "aria-label": _ctx.$t('panel.config.searchPlaceholder')
              }, null, 8, _hoisted_15), [
                [_vModelText, _ctx.query]
              ]),
              _createElementVNode("div", {
                class: "cm-filters",
                role: "group",
                "aria-label": _ctx.$t('panel.config.filterLabel')
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filters, (f) => {
                  return (_openBlock(), _createElementBlock("button", {
                    key: f,
                    type: "button",
                    class: _normalizeClass(["cm-chip", { active: _ctx.filter === f }]),
                    "aria-pressed": _ctx.filter === f,
                    onClick: ($event: any) => (_ctx.filter = f)
                  }, _toDisplayString(_ctx.$t('panel.config.filter.' + f)), 11, _hoisted_17))
                }), 128))
              ], 8, _hoisted_16)
            ]),
            _createElementVNode("section", _hoisted_18, [
              _createElementVNode("h4", _hoisted_19, _toDisplayString(_ctx.$t('panel.config.flagsTitle')), 1),
              (_ctx.visibleFlagGroups.length === 0)
                ? (_openBlock(), _createElementBlock("p", _hoisted_20, _toDisplayString(_ctx.$t('panel.config.noMatches')), 1))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleFlagGroups, (g) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: g.group,
                  class: "cm-group"
                }, [
                  _createElementVNode("h5", _hoisted_21, [
                    _createTextVNode(_toDisplayString(_ctx.$t('panel.config.groups.' + g.group)) + " ", 1),
                    _createElementVNode("span", _hoisted_22, _toDisplayString(g.items.length), 1)
                  ]),
                  _createElementVNode("ul", _hoisted_23, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(g.items, (c) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: c.key,
                        class: _normalizeClass(["cm-row", { 'is-changed': _ctx.isChanged(c) }])
                      }, [
                        _createElementVNode("div", _hoisted_24, [
                          _createElementVNode("input", {
                            id: 'flag-' + c.key,
                            class: "form-check-input",
                            type: "checkbox",
                            role: "switch",
                            checked: _ctx.flagState(c),
                            disabled: _ctx.busy[c.key],
                            onClick: _withModifiers(($event: any) => (_ctx.toggleFlag(c)), ["prevent"])
                          }, null, 8, _hoisted_25)
                        ]),
                        _createElementVNode("div", _hoisted_26, [
                          _createElementVNode("label", {
                            for: 'flag-' + c.key,
                            class: "cm-name"
                          }, _toDisplayString(_ctx.displayName(c)), 9, _hoisted_27),
                          (_ctx.displayName(c) !== c.key)
                            ? (_openBlock(), _createElementBlock("code", _hoisted_28, _toDisplayString(c.key), 1))
                            : _createCommentVNode("", true),
                          (_ctx.descriptionOf(c))
                            ? (_openBlock(), _createElementBlock("p", _hoisted_29, _toDisplayString(_ctx.descriptionOf(c)), 1))
                            : _createCommentVNode("", true),
                          (_ctx.isJsonFlag(c))
                            ? (_openBlock(), _createElementBlock("p", _hoisted_30, _toDisplayString(_ctx.$t('panel.config.jsonFlagHint')), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_31, [
                          _createElementVNode("span", {
                            class: _normalizeClass(["cm-state", _ctx.flagState(c) ? 'on' : 'off'])
                          }, _toDisplayString(_ctx.flagState(c) ? _ctx.$t('panel.config.on') : _ctx.$t('panel.config.off')), 3),
                          (_ctx.isChanged(c))
                            ? (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(_ctx.$t('panel.config.changed', { value: _ctx.defaultLabel(c) })), 1))
                            : _createCommentVNode("", true),
                          (_ctx.isChanged(c))
                            ? (_openBlock(), _createBlock(_component_BaseButton, {
                                key: 1,
                                size: "sm",
                                variant: "secondary",
                                icon: "fas fa-undo",
                                disabled: _ctx.busy[c.key],
                                onClick: ($event: any) => (_ctx.resetEntry(c))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('panel.config.reset')), 1)
                                ]),
                                _: 1
                              }, 8, ["disabled", "onClick"]))
                            : _createCommentVNode("", true)
                        ])
                      ], 2))
                    }), 128))
                  ])
                ]))
              }), 128))
            ]),
            _createElementVNode("section", _hoisted_33, [
              _createElementVNode("h4", _hoisted_34, [
                _createTextVNode(_toDisplayString(_ctx.$t('panel.config.advancedTitle')) + " ", 1),
                _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.visibleAdvanced.length), 1)
              ]),
              _createElementVNode("p", _hoisted_36, _toDisplayString(_ctx.$t('panel.config.advancedHint')), 1),
              (_ctx.visibleAdvanced.length === 0)
                ? (_openBlock(), _createElementBlock("p", _hoisted_37, _toDisplayString(_ctx.$t('panel.config.noMatches')), 1))
                : _createCommentVNode("", true),
              _createElementVNode("ul", _hoisted_38, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleAdvanced, (c) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: c.key,
                    class: _normalizeClass(["cm-adv", { 'is-changed': _ctx.isChanged(c) }])
                  }, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "cm-adv-head",
                      "aria-expanded": _ctx.openKey === c.key,
                      onClick: ($event: any) => (_ctx.toggleOpen(c))
                    }, [
                      _createElementVNode("span", _hoisted_40, [
                        _createElementVNode("span", _hoisted_41, _toDisplayString(c.key), 1),
                        (_ctx.descriptionOf(c))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_42, _toDisplayString(_ctx.descriptionOf(c)), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("span", _hoisted_43, _toDisplayString(_ctx.preview(c.value)), 1),
                      (_ctx.isChanged(c))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_44, _toDisplayString(_ctx.$t('panel.config.changedShort')), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("i", {
                        class: _normalizeClass(["fas", _ctx.openKey === c.key ? 'fa-chevron-up' : 'fa-chevron-down']),
                        "aria-hidden": "true"
                      }, null, 2)
                    ], 8, _hoisted_39),
                    (_ctx.openKey === c.key)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                          _createElementVNode("label", {
                            for: 'adv-' + c.key,
                            class: "cm-label"
                          }, _toDisplayString(_ctx.$t('panel.config.value')), 9, _hoisted_46),
                          (_ctx.editorOf(c) === 'number' || _ctx.editorOf(c) === 'text')
                            ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                key: 0,
                                id: 'adv-' + c.key,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.draft) = $event)),
                                type: _ctx.editorOf(c) === 'number' ? 'number' : 'text',
                                step: "any",
                                class: _normalizeClass(["form-control", { 'is-invalid': _ctx.draftError }])
                              }, null, 10, _hoisted_47)), [
                                [_vModelDynamic, _ctx.draft]
                              ])
                            : _withDirectives((_openBlock(), _createElementBlock("textarea", {
                                key: 1,
                                id: 'adv-' + c.key,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.draft) = $event)),
                                class: _normalizeClass(["form-control cm-textarea", { 'is-invalid': _ctx.draftError, 'cm-mono': _ctx.editorOf(c) === 'json' }]),
                                rows: _ctx.editorOf(c) === 'json' ? 10 : 6,
                                spellcheck: "false"
                              }, null, 10, _hoisted_48)), [
                                [_vModelText, _ctx.draft]
                              ]),
                          (_ctx.draftError)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_49, _toDisplayString(_ctx.$t('panel.config.' + _ctx.draftError)), 1))
                            : _createCommentVNode("", true),
                          (_ctx.isChanged(c))
                            ? (_openBlock(), _createElementBlock("p", _hoisted_50, [
                                _createTextVNode(_toDisplayString(_ctx.$t('panel.config.defaultIs')) + " ", 1),
                                _createElementVNode("code", null, _toDisplayString(_ctx.preview(c.defaultValue || '', 120) || _ctx.$t('panel.config.empty_value')), 1)
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_51, [
                            (_ctx.editorOf(c) === 'json')
                              ? (_openBlock(), _createBlock(_component_BaseButton, {
                                  key: 0,
                                  size: "sm",
                                  variant: "secondary",
                                  icon: "fas fa-align-left",
                                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.draft = _ctx.prettyJson(_ctx.draft)))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('panel.config.format')), 1)
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            _cache[5] || (_cache[5] = _createElementVNode("span", { class: "cm-spacer" }, null, -1)),
                            _createVNode(_component_BaseButton, {
                              size: "sm",
                              variant: "secondary",
                              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.openKey = ''))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('panel.config.cancel')), 1)
                              ]),
                              _: 1
                            }),
                            (_ctx.isChanged(c))
                              ? (_openBlock(), _createBlock(_component_BaseButton, {
                                  key: 1,
                                  size: "sm",
                                  variant: "secondary",
                                  icon: "fas fa-undo",
                                  disabled: _ctx.busy[c.key],
                                  onClick: ($event: any) => (_ctx.resetEntry(c))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('panel.config.reset')), 1)
                                  ]),
                                  _: 1
                                }, 8, ["disabled", "onClick"]))
                              : _createCommentVNode("", true),
                            _createVNode(_component_BaseButton, {
                              size: "sm",
                              solid: "",
                              loading: _ctx.busy[c.key],
                              disabled: !!_ctx.draftError || _ctx.draft === c.value,
                              onClick: ($event: any) => (_ctx.saveDraft(c))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('panel.config.save')), 1)
                              ]),
                              _: 1
                            }, 8, ["loading", "disabled", "onClick"])
                          ]),
                          _createElementVNode("p", _hoisted_52, [
                            _createTextVNode(_toDisplayString(_ctx.$t('panel.config.updatedBy')) + ": " + _toDisplayString(c.updatedBy || _ctx.$t('panel.config.system')) + " ", 1),
                            (c.updatedAt)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createTextVNode(" · " + _toDisplayString(_ctx.formatDate(c.updatedAt)), 1)
                                ], 64))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ], 2))
                }), 128))
              ])
            ])
          ]),
          _: 1
        }, 8, ["loading", "empty", "empty-text", "loading-text"]))
  ]))
}